import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_DOMAIN_BIDDERS } from './api/query'
import { Data, DomainBidderSliceDTO, Variables } from './api/types'
import { DomainBidderSlice, UseGetDomainBidders, UseGetDomainBiddersProps } from './types'

export const useGetDomainBidders = ({
  domainId,
}: UseGetDomainBiddersProps): UseGetDomainBidders => {
  const [domainBidders, setDomainBidders] = useState<DomainBidderSlice[] | undefined>()

  useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        domainBidders: { nodes: bidders },
      } = data

      if (bidders) {
        setDomainBidders(
          bidders.map((bidder: DomainBidderSliceDTO): DomainBidderSlice => fromDTO(bidder)),
        )
      }
    },
    options: {
      enabled: domainId !== undefined,
    },
    query: GET_DOMAIN_BIDDERS,
    variables: {
      domainId: domainId!,
    },
  })

  return { domainBidders }
}
